import TextContainer from "./Favourites";

export default TextContainer;
